var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFastTagYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 -10 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 4.85668V3.64233H1.25C0.56125 3.64233 0 4.18757 0 4.85668V7.28536H9.01375C8.84 6.5434 8.75 5.74436 8.75 4.85668Z",
    fill: "url(#paint0_linear_2933_7852)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9487 9.71387C19.0962 10.9901 17.7962 12.0758 15.9338 13.1152C15.6475 13.2743 15.325 13.3569 15 13.3569C14.675 13.3569 14.3525 13.2743 14.07 13.1177C12.2075 12.0758 10.9075 10.9889 10.0538 9.71387H0V15.7856C0 16.4559 0.56125 16.9999 1.25 16.9999H18.75C19.44 16.9999 20 16.4559 20 15.7856V9.71387H19.9487ZM5.625 13.3569H3.125C2.78 13.3569 2.5 13.0849 2.5 12.7497C2.5 12.4146 2.78 12.1426 3.125 12.1426H5.625C5.97 12.1426 6.25 12.4146 6.25 12.7497C6.25 13.0849 5.97 13.3569 5.625 13.3569Z",
    fill: "url(#paint1_linear_2933_7852)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6212 1.87069L15.2462 0.0491809C15.0875 -0.0163936 14.9113 -0.0163936 14.7525 0.0491809L10.3775 1.87069C10.1488 1.96541 10 2.18521 10 2.42808V4.85676C10 8.19742 11.2713 10.1501 14.6888 12.0627C14.785 12.1161 14.8925 12.1428 15 12.1428C15.1075 12.1428 15.215 12.1161 15.3112 12.0627C18.7287 10.1549 20 8.20228 20 4.85676V2.42808C20 2.18521 19.8512 1.96541 19.6212 1.87069ZM17.3637 4.62968L14.8637 7.66554C14.7437 7.80883 14.5637 7.89262 14.375 7.89262C14.3663 7.89262 14.3563 7.89262 14.3488 7.89262C14.15 7.88412 13.9662 7.78454 13.855 7.62303L12.605 5.80152C12.4137 5.52222 12.4912 5.14578 12.7787 4.95998C13.0637 4.7754 13.4525 4.84826 13.645 5.12877L14.4212 6.25933L16.3863 3.87193C16.6025 3.61085 16.9963 3.56956 17.265 3.77721C17.535 3.98486 17.5775 4.36738 17.3637 4.62968Z",
    fill: "url(#paint2_linear_2933_7852)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2933_7852",
    x1: 2.08549,
    y1: 5.70207,
    x2: 8.94897,
    y2: 5.69799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2933_7852",
    x1: 4.62736,
    y1: 13.8333,
    x2: 19.8563,
    y2: 13.8233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2933_7852",
    x1: 12.3137,
    y1: 6.86543,
    x2: 19.9281,
    y2: 6.86392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastTagYellow);
export default __webpack_public_path__ + "static/media/fast-tag-yellow.41d28beb48c1fa0b92b2cfa359a43a2c.svg";
export { ForwardRef as ReactComponent };